<section [class]="'block-hero-podcast'" class="block-podcast" data-testid="block-podcast">
    <audio #audioElement controls style="display: none">
        <source [src]="podcast.omnyData.audioUrl" type="audio/mpeg" />
    </audio>

    @if (audio) {
    <div class="container-player">
        <div class="podcast-description">
            <h3 class="display-light">{{ podcast.omnyData.title }}</h3>
            <p class="podcast-description-block">{{ podcast.omnyData.description.toString() }}</p>
        </div>
        <div class="podcast-controls">
            <div class="player-podcast">
                <input
                    #progressbar
                    type="range"
                    [attr.data-action]="progressbar"
                    class="slider"
                    min="0"
                    step="0.001"
                    [value]="audio.currentTime"
                    [max]="podcast.omnyData.duration"
                    (input)="changeTime(progressbar.value)"
                    aria-label="Progress bar"
                    i18n-aria-label="@@hermes.accessibility.progress-bar"
                    aria-valuetext="Loading"
                    i18n-aria-valuetext="@@hermes.accessibility.loading"
            /></div>
            <p class="podcast-block-timer">
                <span data-action="current-time" i18n-data-action>{{ timeconverter(audio.currentTime) }}</span>
                <span data-action="total_time" i18n-data-action>{{ totalTime }}</span>
            </p>

            @if (!audio.muted) {
            <button class="volume-button" data-action="mute_button" i18n-data-action (click)="muteAudio()">
                <span i18n="@@hermes.accessibility.mute" hSrOnlyNoSnippet>Mute</span>
                <h-svg-icon class="icon-volume" [name]="'volume-on-button'"></h-svg-icon>
            </button>
            } @if (audio.muted) {
            <button class="volume-button muted" data-action="enable_button" i18n-data-action (click)="muteAudio()">
                <span i18n="@@hermes.accessibility.unmute" hSrOnlyNoSnippet>Enable sound</span>
                <h-svg-icon class="icon-volume" [name]="'volume-mute-button'"></h-svg-icon>
            </button>
            }

            <button data-action="rewind_button" i18n-data-action i18n-data-actio-n (click)="moveRwFw('rewind')">
                <span i18n="@@hermes.accessibility.rewind" hSrOnlyNoSnippet>Rewind by 15 seconds</span>
                <h-svg-icon class="icon-backward" [name]="'rw-button'"></h-svg-icon>
            </button>

            @if (paused) {
            <button class="play-button" data-action="play_button" i18n-data-action (click)="play()">
                <span i18n="@@hermes.accessibility.play" hSrOnlyNoSnippet>play</span>
                <h-svg-icon class="icon-play-pause" [name]="'play-media'"></h-svg-icon>
            </button>
            } @if (!paused) {
            <button class="play-button" data-action="play_button" i18n-data-action (click)="pause()">
                <h-svg-icon class="icon-play-pause" [name]="'pause-media'"></h-svg-icon>
                <span i18n="@@hermes.accessibility.pause" hSrOnlyNoSnippet>pause</span>
            </button>
            }

            <button data-action="forward-button" i18n-data-action (click)="moveRwFw('forward')">
                <span i18n="@@hermes.accessibility.forward" hSrOnlyNoSnippet>Forward by 15 seconds</span>
                <h-svg-icon class="icon-forward" [name]="'fw-button'"></h-svg-icon>
            </button>

            @if (!openSubscribe) {
            <button
                class="subscribe-button"
                data-action="subscribe_button"
                i18n-data-action
                (click)="toggleSubscription()">
                <span i18n="@@hermes.accessibility.subscribe" hSrOnlyNoSnippet>Subscribe to podcast</span>
                <h-svg-icon class="icon-subscribe" [name]="'subscribe-button'"></h-svg-icon>
            </button>
            } @if (openSubscribe) {
            <button
                class="subscribe-button hide"
                data-action="subscribe_button"
                i18n-data-action
                (click)="toggleSubscription()">
                <span i18n="@@hermes.accessibility.close-subscribe" hSrOnlyNoSnippet>Close subscribe to podcast</span>
                <h-svg-icon class="icon-subscribe" [name]="'close-button'"></h-svg-icon>
            </button>
            }
            <ul class="subscribe-dropdown" [ngClass]="openSubscribe ? 'show show-dropdown' : 'hide hide-dropdown'">
                @for (platform of podcast.platforms; track platform) {
                <li class="subscribe-list">
                    <img class="subscribe-img" [src]="platform.icon" [alt]="'Logo ' + platform.title" />

                    <a
                        class="subscribe-link"
                        (click)="subscribeService(platform.title)"
                        [href]="platform.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-track-subscription=""
                        >{{ platform.title
                        }}<span i18n="@@hermes.accessibility.new-window" hSrOnlyNoSnippet>New window</span>
                    </a>
                </li>
                }
            </ul>
        </div>
    </div>
    }
    <div class="container-image">
        <div class="podcast-image">
            <img [src]="podcast.omnyData.imageUrl" alt="" />
        </div>
    </div>
</section>
